export const environment = {
  PRODUCTION: true,
  NAME: '__ENV_NAME__',
  API_BASE_URL: '__API_BASE_URL__',
  SUBMIT_ENDPOINT: '__SUBMIT_ENDPOINT__',
  SUBMIT_NO_DOCUMENT_ENDPOINT: '__SUBMIT_NO_DOCUMENT_ENDPOINT__',
  REGISTRATION_ENDPOINT: '__REGISTRATION_ENDPOINT__',
  VALIDATE_ENDPOINT: '__VALIDATE_ENDPOINT__',
  TOKEN_VERSION: '__TOKEN_VERSION__',
  TOKEN_ENDPOINT: '__TOKEN_ENDPOINT__',
  REFRESH_ENDPOINT: '__REFRESH_ENDPOINT__',
  RECAPTCHA_SITE_KEY: '__RECAPTCHA_SITE_KEY__',
  AUTH_GRANT_TYPE: '__AUTH_GRANT_TYPE__',
  AUTH_CLIENT_ID: '__AUTH_CLIENT_ID__',
  AUTH_CLIENT_SECRET: '__AUTH_CLIENT_SECRET__',
  AUTH_CLIENT_SCOPE: '__AUTH_SCOPE__',

  // Phase 2: GA4 measurement IDs (per-tenant + landing, resolved at container startup from ECS task definition)
  GA4_MEASUREMENT_ID_TTPOI: '__GA4_MEASUREMENT_ID_TTPOI__',
  GA4_MEASUREMENT_ID_CELCOMDIGI: '__GA4_MEASUREMENT_ID_CELCOMDIGI__',
  GA4_MEASUREMENT_ID_MAXIS: '__GA4_MEASUREMENT_ID_MAXIS__',
  GA4_MEASUREMENT_ID_LANDING: '__GA4_MEASUREMENT_ID_LANDING__',
};
